import React from 'react'

import { styled, spacing } from '@thg-commerce/gravity-theme'
import { PartialBy } from '@thg-commerce/gravity-elements/utils/typescript'

import { Image, ImageProps } from '../Image/Image'

interface FigureProps {
  isAmp: boolean
  image: PartialBy<ImageProps, 'isAmp'>
  caption: string
}

const StyledCaption = styled.figcaption`
  padding: ${spacing(1.5)} 0px;
`

export const Figure = React.memo((props: FigureProps) => {
  const caption = props.caption
  const imageWidth = props.isAmp ? '340px' : '100%'
  const imageHeight = props.isAmp ? '350px' : 'auto'
  const ampImageLayout = props.isAmp ? 'responsive' : undefined

  return (
    <figure>
      <Image
        src={props.image.src}
        width={imageWidth}
        height={imageHeight}
        alt={props.image.alt || ''}
        isAmp={props.isAmp}
        ampLayout={ampImageLayout}
        imageStyle="cover"
      />
      <StyledCaption>{caption}</StyledCaption>
    </figure>
  )
})
